import axios from "axios";
import { useUserData } from "@/composables/useUserData";

export const getToken = () => localStorage.getItem("jwt");

export const isAuthenticated = () => Boolean(getToken());

// Stored user data survives a reload, so the token is re-checked against the API
// once per page load before any protected route is trusted.
let sessionVerified = false;

export const isSessionVerified = () => sessionVerified;

export const clearSession = () => {
    sessionVerified = false;
    localStorage.removeItem("jwt");
    useUserData().setUser(null);
};

export function useAuth() {
    const { setUser } = useUserData();

    const login = async ({ email, password }) => {
        // The API rejects the login route for authenticated requests, so any
        // leftover session is dropped before asking for a new token.
        clearSession();

        const res = await axios.post(`${process.env.VUE_APP_API_URL}/login`, {
            email,
            password,
        });

        localStorage.setItem("jwt", res.data.data.token);
    };

    const profile = async () => {
        const response = await axios.get(`${process.env.VUE_APP_API_URL}/profile`);

        setUser(response.data.data);
        sessionVerified = true;

        return response.data.data;
    };

    const updateAvatar = async (avatarFile) => {
        const body = new FormData();
        body.append("avatar", avatarFile);

        const response = await axios.post(
            `${process.env.VUE_APP_API_URL}/profile/avatar`,
            body,
            { headers: { "Content-Type": "multipart/form-data" } }
        );

        setUser(response.data.data);

        return response.data.data;
    };

    const changePassword = async ({
        current_password,
        password,
        password_confirmation,
    }) => {
        await axios.patch(`${process.env.VUE_APP_API_URL}/profile/password`, {
            current_password,
            password,
            password_confirmation,
        });
    };

    const logout = async () => {
        try {
            await axios.delete(`${process.env.VUE_APP_API_URL}/logout`);
        } catch (error) {
            console.log(error);
        } finally {
            clearSession();
        }
    };

    return {
        logout,
        login,
        profile,
        updateAvatar,
        changePassword,
        isAuthenticated,
        clearSession,
        getToken,
    };
}
